<script lang="ts" setup generic="K extends string | number">
import type { CommonType } from '@/typings/common';

export interface TagCheckboxProps<K extends string | number> {
  /** 标签列表 */
  options: CommonType.Option<K>[];
  /** 禁用 */
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  /** 自动提交 */
  autoSubmit?: boolean;
}
defineOptions({
  /** 标签复选组件 */
  name: 'TagCheckbox'
});

const props = withDefaults(defineProps<TagCheckboxProps<K>>(), {
  disabled: false,
  size: 'medium',
  autoSubmit: false
});

const emit = defineEmits<{
  /** 值变化事件 */
  change: [value: K[]];
  /** 提交事件 */
  submit: [value: K[]];
}>();

const model = defineModel<K[]>('value', {
  required: true,
  default: () => []
});

function togger(value: K) {
  if (props.disabled) return;
  if (model.value.includes(value)) {
    model.value.splice(model.value.indexOf(value), 1);
  } else {
    model.value.push(value);
  }
  emit('change', model.value);
  if (props.autoSubmit) {
    // 提交表单
    emit('submit', model.value);
  }
}
</script>

<template>
  <NSpace>
    <template v-for="item of options" :key="item.value">
      <NTag
        :size="size"
        :type="model.includes(item.value) ? 'primary' : undefined"
        :bordered="false"
        :class="disabled ? 'tag-checkBox-disable' : 'tag-checkbox-ntag'"
        @click="togger(item.value)"
      >
        <!-- <template v-if="model.includes(item.value)" #icon>
          <icon-material-symbols-check-circle class="text-icon" />
        </template> -->
        {{ item.label }}
      </NTag>
    </template>
  </NSpace>
</template>

<style scoped>
.tag-checkbox-ntag {
  cursor: pointer;
}
.tag-checkBox-disable {
  cursor: not-allowed;
}
</style>
